import { adapter } from "./adapter";

import type { RootState } from "../store";

export const { selectAll } = adapter.getSelectors<RootState>(
  (state) => state.achCompanies,
);
